import { RouteProp } from '@react-navigation/native';
import React, { useMemo } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import ClientRecordFields, {
    formValueToCreateRequest,
    initialFormValue,
    formValuesFromClientRecord,
    FormValue,
} from '../../../../shared/ClientRecord/ClientRecordFields';
import { useOrganizationClientRecords } from '../../../../../hooks/api/useOrganizationClientRecords';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';

export type EditClientRecordScreenOwnProps = {};

export type EditClientRecordScreenProps = EditClientRecordScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'edit-client-record'>;
};

const EditClientRecordScreen: React.FC<EditClientRecordScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const { updateClientRecord, isUpdatingClientRecord, clientRecord, isLoadingClientRecord } =
        useOrganizationClientRecords({
            onUpdateClientRecordSuccess: goBack,
            organizationClientRecordId: route.params.clientRecordId,
        });

    const isLoading = isLoadingClientRecord || isUpdatingClientRecord || !clientRecord;
    const initialValues = useMemo<FormValue>(
        () => (clientRecord ? formValuesFromClientRecord(clientRecord) : initialFormValue),
        [clientRecord],
    );

    const isDisabled = useIsDisabledByParent(isLoading);

    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialValues}
                    onSubmit={(values) => {
                        const request = formValueToCreateRequest(values);
                        updateClientRecord({
                            organizationClientRecordId: route.params.clientRecordId,
                            update: request,
                        });
                    }}
                    onCancel={goBack}
                    isDisabled={isDisabled}
                >
                    {() => <ClientRecordFields />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditClientRecordScreen);
